import { useQuery } from "@tanstack/react-query";

import useApi from "./useApi";

export type PlutoConversationSummary = {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
};

type PlutoConversationListResponse = {
  conversations: readonly PlutoConversationSummary[];
};

/**
 * Lists the user's Pluto conversations, newest activity first. Kept disabled
 * until the history view is opened so the panel costs nothing to render.
 */
export const usePlutoConversations = (enabled: boolean) => {
  const { instance } = useApi();

  return useQuery<PlutoConversationListResponse>({
    queryKey: ["pluto", "conversations"],
    queryFn: async ({ signal }) => {
      const response = await instance.get<PlutoConversationListResponse>("/v3/pluto/conversations", { signal });
      return response.data;
    },
    enabled,
    retry: 1,
    staleTime: 0,
  });
};

export default usePlutoConversations;
